/**
 * @file index.tsx
 *
 * @fileoverview Main navigation for the website / header.
 */

import { ReactNode } from 'react';
import styles from "./header.module.scss";

export interface NavbarProps {
  /**
   * The content to go inside the header.
   */
  children?: ReactNode;
}

/**
 * Main site navigation / header. Should be used to include the main navigation for the site and
 * branding of the website.
 */
export default function Navbar({ children }: NavbarProps) {
  return (
    <div className={styles.navblock} data-testid="navbar">
      <div className={styles.navblockContainer}>{children}</div>
    </div>
  );
}

export { Navbar };
